import { IStationUserState } from '../../../types'
import { ActionHandlerMap } from '../../../types/common'
import { createActionHandler, mergeMap, removeById } from '../../../utils/state'
import { IStationUserAction } from '../../actions/station-user/'
import * as constants from '../../constants'

const initTeamMemberState: IStationUserState = {
  items: {},
  roles: {},
  isFetching: false,
  isProcessing: false,
  total: 0
}

export function stationUser(state: IStationUserState, action: IStationUserAction): IStationUserState {
  if (typeof state === 'undefined') {
    return initTeamMemberState
  }

  switch (action.type) {
    case constants.STATION_USER_LIST_REQUEST: {
      return { ...state, isFetching: true }
    }

    case constants.STATION_USER_LIST_SUCCESS: {
      const { items, total } = action.payload
      const members = {}
      items.forEach(tm => {
        members[tm.id] = tm
      })
      return {
        ...state,
        isFetching: false,
        items: members,
        total
      }
    }

    case constants.STATION_USER_LIST_FAIL: {
      return {
        ...state,
        isFetching: false,
        error: action.payload
      }
    }

    case constants.CREATE_STATION_USER_REQUEST: {
      return { ...state, isProcessing: true }
    }

    case constants.CREATE_STATION_USER_SUCCESS: {
      const teamMember = action.payload
      const items = mergeMap(state.items, { [teamMember.id]: teamMember })
      return { ...state, items, isProcessing: false }
    }

    case constants.CREATE_STATION_USER_FAIL: {
      return { ...state, error: action.payload, isProcessing: false }
    }

    case constants.STATION_USER_FETCH_REQUEST: {
      return { ...state, isFetching: true }
    }

    case constants.STATION_USER_FETCH_SUCCESS: {
      const teamMember: any = action.payload
      const t = { [teamMember.id]: teamMember }
      return { ...state, items: mergeMap(state.items, t), isFetching: false }
    }

    case constants.STATION_USER_FETCH_FAIL: {
      return { ...state, error: action.payload, isFetching: false }
    }

    case constants.STATION_USER_UPDATE_SUCCESS: {
      const teamMember = action.payload
      return {
        ...state,
        items: mergeMap(state.items, { [teamMember.id]: teamMember })
      }
    }

    case constants.STATION_USER_ARCHIVE_SUCCESS: {
      const teamMember = action.payload
      return { ...state, items: removeById({ ...state.items }, teamMember.id) }
    }

    case constants.STATION_USER_RESTORE_SUCCESS: {
      const teamMember = action.payload
      return { ...state, items: removeById({ ...state.items }, teamMember.id) }
    }

    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/station-user/index.ts